/**
 * Textes des lots d'images et de documents lus dans un dépôt (ARTO-131) : la
 * création, la fiche d'un lot d'images, la revue du rapprochement et les
 * décisions de la galerie. Fichier à part ; son bloc `images` est fusionné dans
 * le namespace `console` (D15). Voix 2.2 : phrases courtes, un geste porte le
 * même nom du bouton au message de fin.
 */

export const frImages = {
  images: {
    liste: {
      bouton: 'Images ou documents d’un dépôt',
      aRapprocher: 'Images d’un dépôt, à rapprocher',
      ambigus_one: '{{count}} fichier ambigu à trancher',
      ambigus_other: '{{count}} fichiers ambigus à trancher',
      rapproche_one: '{{count}} image rapprochée',
      rapproche_other: '{{count}} images rapprochées',
      images_one: '{{count}} image lue',
      images_other: '{{count}} images lues',
      filtrer: 'Filtrer : {{liste}}',
      filtre: 'Filtrer par nom ou chemin',
      total_one: '{{count}} entrée',
      total_other: '{{count}} entrées',
      filtrees_one: '{{count}} entrée sur {{total}} correspond.',
      filtrees_other: '{{count}} entrées sur {{total}} correspondent.',
      tronquee_one: 'Seule la première entrée est listée ; le compteur reste exact.',
      tronquee_other:
        'Seules les {{count}} premières entrées sont listées ; le compteur reste exact.',
      aucuneCorrespondance: 'Aucune entrée ne correspond à ce filtre.',
    },
    nouveau: {
      titre: 'Images ou documents d’un dépôt',
      texte:
        'Reprenez des fichiers déjà déposés : leurs images, rattachées aux œuvres existantes, ou des documents et des factures antérieures. Rien n’est écrit chez la galerie avant l’essai.',
      natureTitre: 'Ce que le lot reprend',
      nature: 'Nature du lot',
      natures: {
        images: 'Images des œuvres',
        documents: 'Documents du coffre',
        'factures-historiques': 'Factures antérieures',
      },
      natureAide: {
        images:
          'Chaque image est rapprochée d’une œuvre existante par son nom. Les cas douteux se tranchent avant tout essai.',
        documents:
          'Un tableur du dépôt liste les documents ; sa colonne « Fichier » cite des chemins du dépôt.',
        'factures-historiques':
          'Un tableur du dépôt liste les factures ; sa colonne « Fichier » cite les PDF du dépôt. Le lancement exige un second facteur récent.',
      },
      lecture: 'Ce que le lot lit',
      dossier: 'Dossier du dépôt',
      dossierExemple: 'Atelier/2026',
      dossierAide: 'Facultatif. Vide : tout le dépôt est lu.',
      remplacer: 'Remplacer l’image principale existante',
      remplacerAide: 'Décoché, une œuvre qui a déjà une image principale la garde.',
      remplacerAvertissement:
        'Attention : pour chaque œuvre qui a déjà une image principale, la première image du lot prendra sa place.',
      manifeste: 'Tableur du dépôt',
      manifesteAide: 'Choisissez le tableur CSV ou XLSX qui décrit les fichiers à reprendre.',
      aucunTableur: 'Aucun tableur CSV ou XLSX accepté sur cette page du manifeste.',
      annuler: 'Annuler',
      rapprocher: 'Rapprocher',
      creer: 'Créer le lot',
      ouvrir: 'Ouvrir le lot',
      rapprochementRefuse:
        'Le lot est créé, mais le rapprochement est refusé : {{message}} Ouvrez le lot pour le relancer.',
      okImages: 'Lot d’images créé, rapprochement lancé.',
      okFichiers: 'Lot créé. Lancez un essai pour voir ce qu’il ferait.',
    },
    fiche: {
      titre: 'Images d’un dépôt',
      lecture: 'Ce que le lot lit',
      depot: 'Dépôt',
      dossier: 'Dossier lu',
      toutLeDepot: 'Tout le dépôt',
      principale: 'Image principale',
      principaleGardee: 'Conservée quand l’œuvre en a déjà une',
      principaleRemplacee: 'Remplacée par la première image du lot',
      rapprocher: 'Rapprocher',
      rapprocherDeNouveau: 'Rapprocher de nouveau',
      rapprocherAide:
        'Le rapprochement lit le dépôt et associe chaque image à une œuvre par son nom. Il ne modifie rien chez la galerie.',
      rapprocherDeNouveauAide:
        'Rapprocher de nouveau relit le dépôt avec vos décisions. Les morceaux déjà lancés l’interdisent.',
      rapprochementEnCours: 'Rapprochement en cours. La page se met à jour toute seule.',
      renonce: 'Le rapprochement a renoncé : {{message}}',
      morceauxLances:
        'Un morceau de ce lot est déjà lancé : le rapprochement ne se refait plus. Créez un nouveau lot pour reprendre autrement.',
      luDansDepot: 'Pièces lues dans le dépôt, vérifiées une à une',
      confirmationTexte_one:
        'Venio va rattacher {{count}} image aux œuvres de la galerie, sous mandat.',
      confirmationTexte_other:
        'Venio va rattacher {{count}} images aux œuvres de la galerie, sous mandat.',
    },
    etapes: {
      depose: 'Déposé',
      rapproche: 'Rapproché',
      tranche: 'Ambigus tranchés',
      essai: 'Essai par morceaux',
      a_lancer: 'Morceaux à lancer',
    },
    revue: {
      titre: 'Revue du rapprochement',
      texte:
        'Chaque image du dépôt est rattachée à une œuvre, orpheline ou ambiguë. Un doute n’est jamais tranché en silence : c’est à vous de décider.',
      erreur: 'La revue du rapprochement n’a pas pu être lue.',
      compteurs: 'Compteurs du rapprochement',
      c: {
        images: 'Images lues',
        rapproches: 'Rapprochées',
        ambigus: 'Ambiguës',
        orphelins: 'Orphelines',
        ignores: 'Ignorées',
        nonPris: 'Non prises en charge',
        aConvertir: 'À convertir (TIFF, GIF)',
        sansImage: 'Œuvres sans image',
        morceaux: 'Morceaux',
      },
      onglet: '{{nom}} ({{count}})',
      onglets: {
        ambigus: 'Ambigus',
        orphelins: 'Orphelins',
        rapproches: 'Rapprochés',
        ignores: 'Ignorés et doublons',
        nonPris: 'Non pris en charge',
        sansImage: 'Œuvres sans image',
      },
      ambigusBloquent_one:
        'Un fichier est ambigu. Tant qu’il n’est pas tranché, aucun morceau n’est produit : ni essai, ni lancement.',
      ambigusBloquent_other:
        '{{count}} fichiers sont ambigus. Tant qu’ils ne sont pas tranchés, aucun morceau n’est produit : ni essai, ni lancement.',
      aucunAmbigu: 'Aucun fichier ambigu.',
      aucunOrphelin: 'Aucun orphelin : chaque image désigne une œuvre.',
      aucunRapproche: 'Aucune image rapprochée.',
      aucunIgnore: 'Aucun fichier ignoré.',
      aucunNonPris: 'Tous les formats lus sont pris en charge.',
      aucuneSansImage: 'Toutes les œuvres ont au moins une image.',
      nonPrisTexte:
        'Listés, non convertis : ces fichiers sont dans un format que les médias n’acceptent pas (TIFF, par exemple). Ils ne sont pas rattachés.',
      sansImageTexte:
        'Les œuvres de la galerie qu’aucune image rapprochée ne couvre. Un orphelin peut leur être rattaché.',
      motifsAmbigus: {
        plusieurs_oeuvres: 'Le nom correspond à plusieurs œuvres',
        plusieurs_ordres: 'Le nom donne plusieurs ordres possibles',
        meme_ordre: 'Un autre fichier vise le même ordre dans l’œuvre',
        decision_invalide: 'La décision précédente désigne une œuvre introuvable',
      },
      motifsOrphelins: {
        aucune_oeuvre: 'Aucune œuvre ne porte ce numéro',
        sans_dossier: 'Le fichier n’est dans aucun dossier',
        artiste_inconnu: 'Le dossier ne porte le nom d’aucun artiste connu',
      },
      motifsIgnores: {
        decision: 'Ignoré sur décision de la galerie',
        doublon: 'Doublon : même contenu qu’un autre fichier de la même œuvre',
      },
      clesLues: 'Numéros lus dans le nom : {{cles}}',
      rattacheA: '{{inventaire}} · {{titre}}, ordre {{ordre}}',
      decide: 'Décision',
      decisionsSansFichier_one: 'Une décision ne désigne aucun fichier de ce lot.',
      decisionsSansFichier_other: '{{count}} décisions ne désignent aucun fichier de ce lot.',
      decisionsRangeesNombre_one: 'Une décision est enregistrée pour ce lot.',
      decisionsRangeesNombre_other: '{{count}} décisions sont enregistrées pour ce lot.',
      decisionsRangees:
        'Les décisions sont enregistrées, mais le rapprochement est refusé : {{message}}',
      rechargee:
        'Le lot venait de changer : la page est rechargée et vos décisions non enregistrées sont retirées. Vérifiez la revue, puis décidez de nouveau.',
      barre: {
        titre: 'Décisions à enregistrer',
        decisions_one: '{{count}} décision à enregistrer',
        decisions_other: '{{count}} décisions à enregistrer',
        restants_one: 'Il reste un ambigu sans décision.',
        restants_other: 'Il reste {{count}} ambigus sans décision.',
        rapprocher: 'Plus aucun ambigu : enregistrez, puis le lot se rapproche de nouveau.',
        annuler: 'Annuler les changements',
        appliquer: 'Enregistrer et rapprocher de nouveau',
      },
    },
    decision: {
      candidates: 'Œuvres possibles',
      oeuvres: 'Œuvres sans image',
      chercher: 'Chercher une œuvre',
      chercherAide: 'Numéro d’inventaire ou titre',
      aucuneOeuvre: 'Aucune œuvre ne correspond.',
      ordre: 'Ordre dans l’œuvre',
      ordreDuNom: 'ordre {{ordre}} d’après le nom',
      ordreAide:
        'Facultatif : sans ordre, c’est celui que le nom du fichier donne. 1 est l’image principale.',
      rattacher: 'Rattacher à cette œuvre',
      ignorer: 'Ignorer',
      retirer: 'Retirer la décision',
      retirerDe: 'Retirer la décision sur {{chemin}}',
      rattache: 'Décision : rattacher à {{oeuvre}}',
      rattacheOrdre: 'Décision : rattacher à {{oeuvre}}, ordre {{ordre}}',
      ignore: 'Décision : ignorer ce fichier',
    },
    essaiLancement: {
      titre: 'Essai et lancement',
      texte:
        'Le plan est découpé en morceaux de 500 fichiers au plus. Chacun s’essaie, puis se lance depuis sa fiche.',
      bloque_one:
        'Un fichier ambigu reste à trancher : l’essai est inactif tant qu’il n’est pas tranché.',
      bloque_other:
        '{{count}} fichiers ambigus restent à trancher : l’essai est inactif tant qu’ils ne sont pas tranchés.',
      aucunMorceau: 'Le rapprochement n’a produit aucun morceau : aucune image à rattacher.',
      converties: 'Converties depuis TIFF ou GIF : {{count}}',
    },
    morceaux: {
      titre_one: '{{count}} morceau du plan',
      titre_other: '{{count}} morceaux du plan',
      colonnes: { lignes: 'Images' },
    },
    essai: {
      titre: 'Essai par morceaux',
      texte:
        'L’essai lit chaque morceau comme un lot ordinaire, sans rien écrire chez la galerie. Le rapport regroupe les refus par message.',
      essayer: 'Essayer les morceaux',
      essayerDeNouveau: 'Essayer de nouveau',
      rapport: 'Essai des morceaux : {{essayes}} sur {{total}}',
      total: 'Images essayées',
      crees: 'Acceptées',
      occurrences_one: '{{count}} image',
      occurrences_other: '{{count}} images',
      occurrence: '{{morceau}}, ligne {{ligne}} du plan : {{libelle}}',
    },
    lancement: {
      parent:
        'Le lot d’origine ne se lance pas : ses morceaux sont les lots à lancer, un par un, depuis leur fiche.',
    },
    erreurs: {
      mandat_absent:
        'Aucun mandat de reprise en vigueur pour cette galerie. Les images ne se rapprochent ni ne se lancent sans mandat : demandez-en un, ou posez celui du contrat.',
      nature_hors_mandat:
        'Le mandat en vigueur ne couvre pas les images des œuvres. Demandez un mandat qui inclut « Images des œuvres ».',
      depot_reinventorie:
        'Le dépôt a été réinventorié depuis la création de ce lot : ses fichiers ont changé. Créez un nouveau lot depuis ce dépôt.',
    },
  },
};

export const enImages: typeof frImages = {
  images: {
    liste: {
      bouton: 'Images or documents from an upload',
      aRapprocher: 'Images from an upload, to match',
      ambigus_one: '{{count}} ambiguous file to settle',
      ambigus_other: '{{count}} ambiguous files to settle',
      rapproche_one: '{{count}} image matched',
      rapproche_other: '{{count}} images matched',
      images_one: '{{count}} image read',
      images_other: '{{count}} images read',
      filtrer: 'Filter: {{liste}}',
      filtre: 'Filter by name or path',
      total_one: '{{count}} entry',
      total_other: '{{count}} entries',
      filtrees_one: '{{count}} entry out of {{total}} matches.',
      filtrees_other: '{{count}} entries out of {{total}} match.',
      tronquee_one: 'Only the first entry is listed; the count stays exact.',
      tronquee_other: 'Only the first {{count}} entries are listed; the count stays exact.',
      aucuneCorrespondance: 'No entry matches this filter.',
    },
    nouveau: {
      titre: 'Images or documents from an upload',
      texte:
        'Take files that are already uploaded: their images, matched to existing artworks, or documents and earlier invoices. Nothing is written to the gallery before the trial.',
      natureTitre: 'What the batch takes',
      nature: 'Kind of batch',
      natures: {
        images: 'Artwork images',
        documents: 'Vault documents',
        'factures-historiques': 'Earlier invoices',
      },
      natureAide: {
        images:
          'Each image is matched to an existing artwork by its name. Doubtful cases are settled before any trial.',
        documents:
          'A spreadsheet in the upload lists the documents; its “File” column cites paths in the upload.',
        'factures-historiques':
          'A spreadsheet in the upload lists the invoices; its “File” column cites the PDFs in the upload. Launching requires a recent second-factor check.',
      },
      lecture: 'What the batch reads',
      dossier: 'Folder of the upload',
      dossierExemple: 'Studio/2026',
      dossierAide: 'Optional. Empty: the whole upload is read.',
      remplacer: 'Replace the existing main image',
      remplacerAide: 'Unchecked, an artwork that already has a main image keeps it.',
      remplacerAvertissement:
        'Careful: for each artwork that already has a main image, the first image of the batch takes its place.',
      manifeste: 'Spreadsheet of the upload',
      manifesteAide: 'Pick the CSV or XLSX spreadsheet that describes the files to take.',
      aucunTableur: 'No accepted CSV or XLSX spreadsheet on this page of the manifest.',
      annuler: 'Cancel',
      rapprocher: 'Match',
      creer: 'Create the batch',
      ouvrir: 'Open the batch',
      rapprochementRefuse:
        'The batch is created, but matching is refused: {{message}} Open the batch to run it again.',
      okImages: 'Image batch created, matching started.',
      okFichiers: 'Batch created. Run a trial to see what it would do.',
    },
    fiche: {
      titre: 'Images from an upload',
      lecture: 'What the batch reads',
      depot: 'Upload',
      dossier: 'Folder read',
      toutLeDepot: 'The whole upload',
      principale: 'Main image',
      principaleGardee: 'Kept when the artwork already has one',
      principaleRemplacee: 'Replaced by the first image of the batch',
      rapprocher: 'Match',
      rapprocherDeNouveau: 'Match again',
      rapprocherAide:
        'Matching reads the upload and links each image to an artwork by its name. It changes nothing in the gallery.',
      rapprocherDeNouveauAide:
        'Matching again rereads the upload with your decisions. A chunk that is already launched forbids it.',
      rapprochementEnCours: 'Matching in progress. The page updates by itself.',
      renonce: 'Matching gave up: {{message}}',
      morceauxLances:
        'A chunk of this batch is already launched: matching cannot be redone. Create a new batch to start over.',
      luDansDepot: 'Files read in the upload, checked one by one',
      confirmationTexte_one:
        'Venio will attach {{count}} image to the gallery’s artworks, under mandate.',
      confirmationTexte_other:
        'Venio will attach {{count}} images to the gallery’s artworks, under mandate.',
    },
    etapes: {
      depose: 'Uploaded',
      rapproche: 'Matched',
      tranche: 'Ambiguities settled',
      essai: 'Trial by chunk',
      a_lancer: 'Chunks to launch',
    },
    revue: {
      titre: 'Matching review',
      texte:
        'Each image in the upload is matched to an artwork, orphaned or ambiguous. A doubt is never settled silently: it is yours to decide.',
      erreur: 'The matching review could not be read.',
      compteurs: 'Matching counts',
      c: {
        images: 'Images read',
        rapproches: 'Matched',
        ambigus: 'Ambiguous',
        orphelins: 'Orphaned',
        ignores: 'Ignored',
        nonPris: 'Unsupported',
        aConvertir: 'To convert (TIFF, GIF)',
        sansImage: 'Artworks without image',
        morceaux: 'Chunks',
      },
      onglet: '{{nom}} ({{count}})',
      onglets: {
        ambigus: 'Ambiguous',
        orphelins: 'Orphans',
        rapproches: 'Matched',
        ignores: 'Ignored and duplicates',
        nonPris: 'Unsupported',
        sansImage: 'Artworks without image',
      },
      ambigusBloquent_one:
        'One file is ambiguous. Until it is settled, no chunk is produced: no trial, no launch.',
      ambigusBloquent_other:
        '{{count}} files are ambiguous. Until they are settled, no chunk is produced: no trial, no launch.',
      aucunAmbigu: 'No ambiguous file.',
      aucunOrphelin: 'No orphan: every image points to an artwork.',
      aucunRapproche: 'No image matched.',
      aucunIgnore: 'No file ignored.',
      aucunNonPris: 'Every format read is supported.',
      aucuneSansImage: 'Every artwork has at least one image.',
      nonPrisTexte:
        'Listed, not converted: these files are in a format the media do not accept (TIFF, for example). They are not attached.',
      sansImageTexte:
        'The gallery’s artworks that no matched image covers. An orphan can be attached to them.',
      motifsAmbigus: {
        plusieurs_oeuvres: 'The name matches several artworks',
        plusieurs_ordres: 'The name gives several possible orders',
        meme_ordre: 'Another file aims at the same order in the artwork',
        decision_invalide: 'The previous decision points to an artwork that cannot be found',
      },
      motifsOrphelins: {
        aucune_oeuvre: 'No artwork carries this number',
        sans_dossier: 'The file is in no folder',
        artiste_inconnu: 'The folder is not named after any known artist',
      },
      motifsIgnores: {
        decision: 'Ignored by the gallery’s decision',
        doublon: 'Duplicate: same content as another file of the same artwork',
      },
      clesLues: 'Numbers read in the name: {{cles}}',
      rattacheA: '{{inventaire}} · {{titre}}, order {{ordre}}',
      decide: 'Decision',
      decisionsSansFichier_one: 'One decision points to no file of this batch.',
      decisionsSansFichier_other: '{{count}} decisions point to no file of this batch.',
      decisionsRangeesNombre_one: 'One decision is saved for this batch.',
      decisionsRangeesNombre_other: '{{count}} decisions are saved for this batch.',
      decisionsRangees: 'The decisions are saved, but matching is refused: {{message}}',
      rechargee:
        'The batch had just changed: the page is reloaded and your unsaved decisions are dropped. Check the review, then decide again.',
      barre: {
        titre: 'Decisions to save',
        decisions_one: '{{count}} decision to save',
        decisions_other: '{{count}} decisions to save',
        restants_one: 'One ambiguous file still has no decision.',
        restants_other: '{{count}} ambiguous files still have no decision.',
        rapprocher: 'No ambiguous file left: save, then the batch is matched again.',
        annuler: 'Discard the changes',
        appliquer: 'Save and match again',
      },
    },
    decision: {
      candidates: 'Possible artworks',
      oeuvres: 'Artworks without image',
      chercher: 'Search for an artwork',
      chercherAide: 'Inventory number or title',
      aucuneOeuvre: 'No artwork matches.',
      ordre: 'Order in the artwork',
      ordreDuNom: 'order {{ordre}} from the name',
      ordreAide:
        'Optional: without an order, the one the file name gives is used. 1 is the main image.',
      rattacher: 'Attach to this artwork',
      ignorer: 'Ignore',
      retirer: 'Remove the decision',
      retirerDe: 'Remove the decision on {{chemin}}',
      rattache: 'Decision: attach to {{oeuvre}}',
      rattacheOrdre: 'Decision: attach to {{oeuvre}}, order {{ordre}}',
      ignore: 'Decision: ignore this file',
    },
    essaiLancement: {
      titre: 'Trial and launch',
      texte:
        'The plan is cut into chunks of 500 files at most. Each one is tried, then launched from its own page.',
      bloque_one: 'One ambiguous file is left to settle: the trial stays off until it is settled.',
      bloque_other:
        '{{count}} ambiguous files are left to settle: the trial stays off until they are settled.',
      aucunMorceau: 'Matching produced no chunk: there is no image to attach.',
      converties: 'Converted from TIFF or GIF: {{count}}',
    },
    morceaux: {
      titre_one: '{{count}} plan chunk',
      titre_other: '{{count}} plan chunks',
      colonnes: { lignes: 'Images' },
    },
    essai: {
      titre: 'Trial by chunk',
      texte:
        'The trial reads each chunk like an ordinary batch, writing nothing to the gallery. The report groups refusals by message.',
      essayer: 'Try the chunks',
      essayerDeNouveau: 'Try again',
      rapport: 'Chunk trial: {{essayes}} of {{total}}',
      total: 'Images tried',
      crees: 'Accepted',
      occurrences_one: '{{count}} image',
      occurrences_other: '{{count}} images',
      occurrence: '{{morceau}}, plan row {{ligne}}: {{libelle}}',
    },
    lancement: {
      parent:
        'The original batch does not launch: its chunks are the batches to launch, one by one, from their own page.',
    },
    erreurs: {
      mandat_absent:
        'No migration mandate in force for this gallery. Images are neither matched nor launched without a mandate: request one, or set the contract mandate.',
      nature_hors_mandat:
        'The mandate in force does not cover artwork images. Request a mandate that includes “Artwork images”.',
      depot_reinventorie:
        'The upload was inventoried again after this batch was created: its files have changed. Create a new batch from this upload.',
    },
  },
};
